import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {hoverSelector} from '../../../../../../libs/shared/helpers/src/browser/hoverHelpers';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';

/*
 * Props.
 */

export interface FrameCardPinProps {
  isPinned?: boolean;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  grid-area: pin;
  padding: 5px;
`;

interface PinStyleProps {
  $isEnabled: boolean;
}

const StyledPinDiv = styled.div<PinStyleProps>`
  padding: 5px;
  border-radius: 50%;

  ${(p) => addColorStyle(p.$isEnabled)}
`;

function addColorStyle(isEnabled: boolean) {
  if (isEnabled) {
    return css`
      color: ${(p) => p.theme.palette.blue.shade40};

      ${hoverSelector} {
        color: ${(p) => p.theme.palette.blue.shade50};
      }
    `;
  }

  return css`
    color: ${(p) => p.theme.greys.shade50};

    ${hoverSelector} {
      color: ${(p) => p.theme.greys.shade70};
    }
  `;
}

/*
 * Component.
 */

export const FrameCardPin: FC<FrameCardPinProps> = (props) => (
  <StyledWrapperDiv>
    <StyledPinDiv $isEnabled={Boolean(props.isPinned)}>
      <Icon name="pinSmall" />
    </StyledPinDiv>
  </StyledWrapperDiv>
);
